import axios from "axios";

const baseService = axios.create({
  baseURL: "/api/"
});

// baseService.interceptors.response.use(function (response) {
//     // Do something with response data
//     return response;
// }, function (error) {
//     // Do something with response error
//     return Promise.reject();
// });

export default baseService;
